@let employee =
  employeesEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();
@let isSubmitting =
  employeesEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
@let isSaveEnabled = isSaveEnabledSg();
@let hasDuplicates =
  employeeDuplicateDetectionPlugin.feature.selectors.hasDuplicates.asSignal();
@let isCheckingDuplicates =
  employeeDuplicateDetectionPlugin.feature.selectors.isChecking.asSignal();
@let departmentEc = organizationsFeature.selectors.departmentEc.asSignal();

<atn-ds-centered-overlay type="narrow">
  <atn-ds-widget title="Create Employee">
    <i
      actions
      class="atn-icon atn-close atn-red"
      (click)="cancelClickHandler()"
    ></i>

    <div class="atn-create-employee-form__content">
      <atn-ds-text
        label="Name"
        placeholder="Enter name"
        [value]="employee?.name"
        (onInput)="updateEmployeeHandler({ name: $event })"
      />

      @if (departmentEc) {
        <atn-ds-select-single-ec
          label="Department"
          placeholder="Select department"
          descriptor="Employee.departmentId"
          [collection]="departmentEc"
          [selectionTarget]="employeesEc.associations?.selectionTarget"
          [config]="{
            overlay: {
              hasSearch: true,
            },
          }"
          [required]="true"
        />
      }
      <atn-ds-select-single-ec
        label="Job Title"
        placeholder="Select job title"
        descriptor="Employee.jobTitleId"
        [collection]="jobTitlesEc"
        [selectionTarget]="employeesEc.associations?.selectionTarget"
        [config]="{
          overlay: {
            hasSearch: true,
          },
        }"
      />

      <div class="atn-create-employee-form__warning">
        @if (hasDuplicates) {
          <atn-ds-notice
            description="An employee with this name and job title already exists in the selected organization."
            [style]="DisplayStyle.Warning"
          />
        }
        @if (isCheckingDuplicates) {
          <atn-ds-notice
            [style]="DisplayStyle.Info"
            description="Checking for duplicates..."
          />
        }
      </div>
    </div>

    <div
      footer
      class="atn-create-employee-form__footer"
    >
      @if (hasDuplicates) {
        <atn-ds-button (click)="selectDuplicatesClickHandler()"
          >Select Duplicate</atn-ds-button
        >
      }

      <div class="atn-create-employee-form__footer-action-buttons">
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          [disabled]="!isSaveEnabled"
          [loading]="isSubmitting"
          (click)="saveClickHandler()"
          >Save</atn-ds-button
        >
      </div>
    </div>
  </atn-ds-widget>
</atn-ds-centered-overlay>
